
export const getNumberFromEvent = (event: any, isInt = true) => {
  const str = event.target.value.toString().replace(/,/g, '');
  const value = isInt ? Number.parseInt(str, 10) : Number.parseFloat(str);

  if (Number.isNaN(value)) {
    return '';
  }

  if (value < 0) {
    return 0;
  }

  return value;
};

export const calculate = (
	filingSatus: string,  // filing status
	dependents: number,  // How many dependents did you claim on your 2020 tax return
	income: number, // the adjusted gross income reported on your 2020 tax return
) => {

  let A: number = 600; // base

  const B = dependents;
  const C = income;

  let D: number; // Phase-Out Threshold
  switch (filingSatus) {
    case "married-jointly":
    case "widower":
      D = 150000;
      break;
    case "head-houshold":
      D = 112500;
      break;
    case "single":
    case "married-separately":
      D = 75000;
      break;
    default:
      D = 0;
  }

  if(D === 150000 && filingSatus !== "widower"){
    A = 1200;
  }

  const combinedAmount = A + (B * 600);

  let reduction = (C - D) * 0.05;
  if (reduction < 0) { reduction = 0; }

  let monthlyPayment = combinedAmount - reduction;

  if(monthlyPayment <= 0) { monthlyPayment = 0; }

  return {
    monthlyPayment,
  };
};
